import { cotopaxiVersion } from '@as/cotopaxi';
export default () => cotopaxiVersion;
